import { render } from "./market-overview.vue?vue&type=template&id=1934a2f2"
import script from "./market-overview.js?vue&type=script&lang=js"
export * from "./market-overview.js?vue&type=script&lang=js"

import "./market-overview.vue?vue&type=style&index=0&id=1934a2f2&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__